module.exports = __webpack_public_path__ + "img/top-category-beauty.60ce6665.jpg";